module.exports = __webpack_public_path__ + "img/dog-icon.ccfa0d29.svg";